import { useTranslation } from "react-i18next";
import type { Project } from "~/api/governanceTypes";
import { ABILITY } from "~/api/types";
import { GitConnectionsPanel } from "~/features/git/GitConnectionsPanel";
import { Button } from "~/foundation/components/Button";
import { Dialog } from "~/foundation/components/Dialog";
import { usePolicy } from "~/policies/usePolicy";

/** A project's repositories, from its row menu — the shared panel, pre-scoped. */
export function ProjectRepositoriesDialog({
  project,
  onClose,
}: {
  project: Project;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const can = usePolicy(project.id);

  return (
    <Dialog
      open
      onOpenChange={(open) => !open && onClose()}
      title={t("Repositories — {{name}}", { name: project.name })}
      description={t(
        "What this project reads from git. Its structure appears under the project in the sidebar.",
      )}
      closeLabel={t("Close")}
      size="lg"
      footer={
        <Button variant="primary" onClick={onClose}>
          {t("Done")}
        </Button>
      }
    >
      <GitConnectionsPanel projectId={project.id} canManage={can[ABILITY.projectUpdate] === true} />
    </Dialog>
  );
}
